import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PrimaryButton from '@components/PrimaryButton';
import OrderStatusTabs from '@components/PointServiceComponents/OrderStatusTabs';
import ServiceItemCard from '@components/PointServiceComponents/ServiceItemCard';
import { HeaderLayout, AnimationLayout } from '@layouts';
import { IconButton } from '@material-ui/core';
import { FilterList as Filter } from '@material-ui/icons';
import {
  useOrderContext,
  useServiceItemsContext,
  useAnimateServiceItem,
} from '@hooks';
import { WithStaffCheckIn } from '@HOC';
import { formateServiceItemsList, filterByServiceSections } from '@utils';
import { useStyles } from './styles';
import { fetchServiceSections } from '@api';
import ServiceSectionDialog from '@components/ServiceSectionDialog';

const POSOrders = () => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation('pointOfService');

  const {
    connectToWebSocket,
    isError: isErrorWebSocket,
    serviceItemsList,
    serviceItemsGroupStatus,
    alterServiceItemsGroupStatus,
  } = useServiceItemsContext();

  const { fetchOrderData } = useOrderContext();

  const convertServiceSectionsToObject = (array, key) => {
    const initialValue = {};
    return array.reduce((obj, item) => {
      return {
        ...obj,
        [item[key]]: true,
      };
    }, initialValue);
  };
  useEffect(() => {
    fetchServiceSections().then(data => {
      const sections = convertServiceSectionsToObject(
        data.serviceSections,
        'id',
      );
      if (!localStorage.getItem('filterState')) {
        setValue(sections);
      }
      setServiceSections(data.serviceSections);

      // localStorage.setItem('filterState', JSON.stringify(sections));
    });
  }, []); // eslint-disable-line

  const { animation, setAnimation } = useAnimateServiceItem(
    serviceItemsGroupStatus,
  );
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState(
    JSON.parse(localStorage.getItem('filterState')) || {},
  );
  const [orderItemsList, setOrderItemsList] = useState([]);
  const [serviceSections, setServiceSections] = useState([]);
  const [expandedMap, setExpandedMap] = useState({
    prevId: '',
    currentId: '',
  });

  const handleAccordionChange = ({ panelId, orderId }) => async event => {
    event.stopPropagation();

    setExpandedMap(prevState => {
      return {
        prevId: prevState.currentId,
        currentId: panelId,
      };
    });

    if (orderId) {
      await fetchOrderData({ orderId });
    }
  };

  const handleTabsChange = (event, newValue) => {
    alterServiceItemsGroupStatus(newValue);
    setAnimation({});
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleFilter = values => {
    const orderList = filterByServiceSections(orderItemsList, values);
    setValue(values);
    localStorage.setItem('filterState', JSON.stringify(values));
    setOrderItemsList(orderList);
    setOpen(false);
  };
  useEffect(() => {
    connectToWebSocket();
  }, []); // eslint-disable-line

  useEffect(() => {
    const filteredServiceItemsList = serviceItemsList.filter(
      item => value[item.serviceSection],
    );
    const sortedOrderItemsList = formateServiceItemsList(
      filteredServiceItemsList,
      serviceItemsGroupStatus,
    );

    if (Object.keys(value).length === 0) {
      setOrderItemsList(sortedOrderItemsList);
    } else {
      const orderList = filterByServiceSections(sortedOrderItemsList, value);
      setOrderItemsList(orderList);
    }
  }, [serviceItemsList, serviceItemsGroupStatus, value]);
  if (isErrorWebSocket) {
    return (
      <div className={classes.errorPart}>
        <p className={classes.errorMessage}>{t('someErrorOccured')}</p>
        <PrimaryButton
          text={t('buttons.backToScanButton')}
          handleClick={() => history.push('/service')}
        />
      </div>
    );
  }

  const isNeitherCardExpandedYet = Object.values(expandedMap).every(
    item => item.length === 0,
  );

  return (
    <HeaderLayout>
      <div>
        <IconButton
          color="primary"
          style={{ position: 'absolute', right: 50, top: 80, color: '#FF9B07' }}
          onClick={() => setOpen(true)}
        >
          {' '}
          <Filter />{' '}
        </IconButton>

        <OrderStatusTabs
          value={serviceItemsGroupStatus}
          onChange={handleTabsChange}
        />
        <AnimationLayout animation={animation}>
          <div className={classes.content}>
            <div className={classes.cardsList}>
              {orderItemsList.length > 0 ? (
                orderItemsList.map(orderItem => (
                  <div key={orderItem.id}>
                    <ServiceItemCard
                      orderDataMap={orderItem}
                      expandedMap={expandedMap}
                      isNeitherCardExpandedYet={isNeitherCardExpandedYet}
                      handleAccordionChange={handleAccordionChange}
                    />
                  </div>
                ))
              ) : (
                <div className={classes.messageOrderDontExist}>
                  {t('noItems')}
                </div>
              )}
            </div>
          </div>
        </AnimationLayout>
      </div>
      <ServiceSectionDialog
        id="serviceSection-menu"
        keepMounted
        open={open}
        onClose={handleClose}
        onFilter={handleFilter}
        value={value}
        options={serviceSections}
      />
    </HeaderLayout>
  );
};

export default WithStaffCheckIn(POSOrders);
